import React, { useState, useEffect, useRef } from "react";
import "./SchedulePayrollBatch.scss";
import { serviceUrl } from "../../config";
import { getBaseUrl } from "../../util/utilfunctions/getbaseurl";
import {
  ScheduleEntryAdd3,
  AddTransFileRecs,
  GetMerchantProfile,
  ValidatePayrollFileRecords,
  ScheduleJobList5,
  ScheduleJobList6
} from "../../util/API/batch";
import { useSelector } from "react-redux";
import Papa from "papaparse";
import PinPad from "../PinPad/PinPad";
import CustomAlert from "../UI/CustomAlert/CustomAlert";
import {
  Box,
  Typography,
  Button,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { commonRunQuery } from "../../util/API/loans";
import {
  decodeHtmlEntities,
  setAsArray,
} from "../../util/utilfunctions/utilFunctions";
import * as XLSX from "xlsx";
const templateUrl = getBaseUrl(serviceUrl);

function SchedulePayrollBatch({ batchList, userPermissions }) {
  let PAYROLL_CATEGORY_ID = "33";

  const [selectedDateTime, setSelectedDateTime] = useState("");
  const [csvData, setCsvData] = useState([]);
  const [piIdsArr, setPiIdsArr] = useState(new Map());
  const [fileName, setFileName] = useState("");
  const [originalFileName, setOriginalFileName] = useState("");
  const [uploadLocation, setUploadLocation] = useState("");
  const [notes, setNotes] = useState("");
  const [totalAmount, setTotalAmount] = useState("0.00");
  const [successfulSchedule, setSuccessfulSchedule] = useState(false);
  const [showPinPad, setShowPinPad] = useState(false);
  const [displayedFileName, setDisplayedFileName] = useState("");
  const [validating, setValidating] = useState(false);
  const [pinProcessing, setPinProcessing] = useState(false);
  // const [customerIdByRow, setCustomerIdByRow] = useState({});
  const [alert, setAlert] = useState({
    open: false,
    message: "",
    severity: "success",
    header: "Success",
  });
  const [validationErrors, setValidationErrors] = useState([]);
  const [isParsing, setIsParsing] = useState(false);
  const [companyName, setCompanyName] = useState("Unknown_Company");
  const [uploadProgress, setUploadProgress] = useState({
    isUploading: false,
    processed: 0,
    total: 0,
    message: "",
  });

  const fileInputRef = useRef(null);
  const isSubmittingRef = useRef(false);
  const VALID_COUNTRY_CODES = new Set([
    "000",
    "4PA",
    "ABW",
    "AFG",
    "AGO",
    "AIA",
    "ALA",
    "ALB",
    "AND",
    "ANT",
    "ARE",
    "ARG",
    "ARM",
    "ASC",
    "ASM",
    "ATA",
    "ATG",
    "AUS",
    "AUT",
    "AZE",
    "BDI",
    "BEL",
    "BEN",
    "BFA",
    "BGD",
    "BGR",
    "BHR",
    "BHS",
    "BIH",
    "BLR",
    "BLZ",
    "BMU",
    "BOL",
    "BRA",
    "BRB",
    "BRN",
    "BTN",
    "BWA",
    "CAF",
    "CAN",
    "CCK",
    "CHE",
    "CHL",
    "CHN",
    "CIV",
    "CMR",
    "COD",
    "COG",
    "COK",
    "COL",
    "COM",
    "CPV",
    "CRI",
    "CUB",
    "CXR",
    "CYM",
    "CYP",
    "CZE",
    "DEU",
    "DJI",
    "DMA",
    "DNK",
    "DOM",
    "DZA",
    "ECU",
    "EGY",
    "ERI",
    "ESH",
    "ESP",
    "EST",
    "ETH",
    "FIN",
    "FJI",
    "FLK",
    "FRA",
    "FRO",
    "FSM",
    "GAB",
    "GBR",
    "GEO",
    "GHA",
    "GIB",
    "GIN",
    "GLP",
    "GMB",
    "GNB",
    "GNQ",
    "GRC",
    "GRD",
    "GRL",
    "GTM",
    "GUF",
    "GUM",
    "GUY",
    "HKG",
    "HND",
    "HRV",
    "HTI",
    "HUN",
    "IDN",
    "IND",
    "IOT",
    "IRL",
    "IRN",
    "IRQ",
    "ISL",
    "ISR",
    "ITA",
    "JAM",
    "JOR",
    "JPN",
    "KAZ",
    "KEN",
    "KGZ",
    "KHM",
    "KIR",
    "KNA",
    "KOR",
    "KWT",
    "LAO",
    "LBN",
    "LBR",
    "LBY",
    "LCA",
    "LIE",
    "LKA",
    "LSO",
    "LTU",
    "LUX",
    "LVA",
    "MAC",
    "MAR",
    "MCO",
    "MDA",
    "MDG",
    "MDV",
    "MEX",
    "MHL",
    "MKD",
    "MLI",
    "MLT",
    "MMR",
    "MNE",
    "MNG",
    "MNP",
    "MOZ",
    "MRT",
    "MSR",
    "MTQ",
    "MUS",
    "MWI",
    "MYS",
    "MYT",
    "NAM",
    "NCL",
    "NER",
    "NFK",
    "NGA",
    "NIC",
    "NIU",
    "NLD",
    "NOR",
    "NPL",
    "NRU",
    "NZL",
    "OMN",
    "PAK",
    "PAN",
    "PCN",
    "PER",
    "PHL",
    "PLW",
    "PNG",
    "POL",
    "PRI",
    "PRK",
    "PRT",
    "PRY",
    "PSE",
    "PYF",
    "QAT",
    "REU",
    "ROU",
    "RUS",
    "RWA",
    "SAU",
    "SDN",
    "SEN",
    "SGP",
    "SHN",
    "SLB",
    "SLE",
    "SLV",
    "SMR",
    "SOM",
    "SPM",
    "SRB",
    "SSD",
    "STP",
    "SUR",
    "SVK",
    "SVN",
    "SWE",
    "SWZ",
    "SYC",
    "SYR",
    "TCA",
    "TCD",
    "TGO",
    "THA",
    "TJK",
    "TKL",
    "TKM",
    "TLS",
    "TON",
    "TTO",
    "TUN",
    "TUR",
    "TUV",
    "TWN",
    "TZA",
    "UGA",
    "UKR",
    "UMI",
    "URY",
    "USA",
    "UZB",
    "VAT",
    "VCT",
    "VEN",
    "VGB",
    "VIR",
    "VNM",
    "VUT",
    "WLF",
    "WSM",
    "YEM",
    "ZAF",
    "ZMB",
    "ZWE",
  ]);

  const VALID_CURRENCIES = new Set([
    "BDT",
    "BSD",
    "CAD",
    "EGP",
    "EUR",
    "GBP",
    "GNR",
    "TZS",
    "USD",
    "UXP",
    "XOF",
  ]);

  const MAX_AMOUNT_PER_ACCOUNT = 10000;

  const merchantInfo = useSelector((state) => state.login.user);

  useEffect(() => {
    const fetchCompanyName = async () => {
      if (merchantInfo?.id) {
        try {
          const res = await GetMerchantProfile("", merchantInfo.id);
          if (res?.callStatus === "1") {
            const businessname =
              res.payload?.Merchant?.businessname || "Unknown_Company";
            setCompanyName(
              businessname
                .replace(/&amp;amp;/g, "&")
                .replace(/&amp;#039;/g, "'")
                .replace(/&amp;#39;/g, "'")
                .replace(/&amp;/g, "&")
                .replace(/&quot;/g, '"')
                .replace(/&#34;/g, '"')
                .replace(/&#039;/g, "'")
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">")
                .replace(/&#39;/g, "'")
                .trim(),
            );
          }
        } catch (err) {
          console.error("Failed to fetch merchant profile:", err);
        }
      }
    };
    fetchCompanyName();
  }, [merchantInfo?.id]);
  /**
   * Sniffs the encoding of a File/Blob by reading its raw bytes.
   * Returns a string suitable for FileReader.readAsText() and Papa.parse({ encoding }).
   *
   * Logic:
   *   1. BOM present → use BOM-declared encoding
   *   2. All bytes valid UTF-8 → "utf-8"
   *   3. Otherwise → "windows-1252"  (safest fallback for Excel/Windows CSVs;
   *      maps all 256 byte values, 0xa0 → U+00A0 Non-Breaking Space)
   */
  const detectFileEncoding = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const buf = new Uint8Array(e.target.result);

        // 1. Check BOM
        if (buf[0] === 0xef && buf[1] === 0xbb && buf[2] === 0xbf)
          return resolve("utf-8");
        if (buf[0] === 0xff && buf[1] === 0xfe) return resolve("utf-16le");
        if (buf[0] === 0xfe && buf[1] === 0xff) return resolve("utf-16be");

        // 2. Try to validate as UTF-8
        let i = 0;
        let isValidUtf8 = true;
        while (i < buf.length) {
          const b = buf[i];
          let extraBytes = 0;
          if (b <= 0x7f) {
            i++;
            continue;
          } // ASCII
          else if (b >= 0xc2 && b <= 0xdf)
            extraBytes = 1; // 2-byte seq
          else if (b >= 0xe0 && b <= 0xef)
            extraBytes = 2; // 3-byte seq
          else if (b >= 0xf0 && b <= 0xf4)
            extraBytes = 3; // 4-byte seq
          else {
            isValidUtf8 = false;
            break;
          } // invalid start byte

          for (let j = 1; j <= extraBytes; j++) {
            if (i + j >= buf.length || (buf[i + j] & 0xc0) !== 0x80) {
              isValidUtf8 = false;
              break;
            }
          }
          if (!isValidUtf8) break;
          i += 1 + extraBytes;
        }

        resolve(isValidUtf8 ? "utf-8" : "windows-1252");
      };
      // Read only first 64KB — enough to detect encoding, fast for large files
      reader.readAsArrayBuffer(file.slice(0, 65536));
    });
  };
  const normalizeBirthdate = (dateStr) => {
    if (!dateStr || typeof dateStr !== "string") return "";
    let s = dateStr.trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
    s = s.replace(/[/\s.,\\-]+/g, "-");
    const parts = s
      .split("-")
      .map((p) => p.trim())
      .filter(Boolean)
      .map(Number);
    if (parts.length !== 3) return "";
    let [a, b, c] = parts;
    if ((c >= 1900 && c <= 2100) || c < 100) {
      const year = c < 100 ? (c <= 30 ? 2000 + c : 1900 + c) : c;
      const day = a;
      const month = b;
      if (day >= 1 && day <= 31 && month >= 1 && month <= 12) {
        return `${year}-${month.toString().padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
      }
    }
    if (a >= 1900 && a <= 2100) {
      const year = a;
      const month = b;
      const day = c;
      if (day >= 1 && day <= 31 && month >= 1 && month <= 12) {
        return `${year}-${month.toString().padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
      }
    }
    return "";
  };

  const getNormalizedHeader = (header) => {
    return header
      .toString()
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "_")
      .replace(/_+/g, "_");
  };
  const reencodeToUtf8 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        // Read as ISO-8859-1, write back as UTF-8
        const text = e.target.result;
        const utf8Bytes = new TextEncoder().encode(text);
        const utf8File = new File([utf8Bytes], file.name, { type: "text/csv" });
        resolve(utf8File);
      };
      reader.onerror = reject;
      reader.readAsText(file, "windows-1252"); // covers ISO-8859-1 + 0xa0
    });
  };
  const cleanFileName = (fileName) => {
    if (!fileName) return "—";
    return fileName
      .replace(/&amp;/g, "&")
      .replace(/&#39;|&apos;/g, "'")
      .replace(/[()]/g, "")
      .replace(/[^a-zA-Z0-9\s'._-]/g, "")
      .replace(/\s+/g, "_")
      .replace(/_+/g, "_")
      .trim();
  };
  const isValidEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email).trim());
  const sanitizeCell = (value) => {
    if (value === null || value === undefined) return "";
    return String(value)
      .replace(/^\uFEFF/, "") // strip BOM
      .replace(/[\u0000-\u001F\u007F]/g, " ") // control characters
      .replace(/\u00A0/g, " ") // proper Non-Breaking Space (U+00A0)
      .replace(/\uFFFD/g, "") // UTF-8 replacement character (garbled bytes)
      .replace(/[\u200B-\u200D\u2060\u180E\uFEFF\u00AD]/g, "") // zero-width / soft-hyphen
      .replace(/[""]/g, '"') // smart quotes
      .replace(/['']/g, "'") // smart apostrophes
      .replace(/…/g, "...") // ellipsis
      .replace(/[^\u0009\u000A\u000D\u0020-\u007E\u00A1-\u00FF]/g, "") // ← NEW: nuke anything outside printable ASCII + Latin-1 printable range
      .trim();
  };
  const ALLOWED_COLUMNS = new Set([
    "first_name",
    "last_name",
    "lastname",
    "birthdate",
    "dob",
    "date_of_birth",
    "address",
    "address1",
    "address_1",
    "address2",
    "address_2",
    "phone_number",
    "phone",
    "mobile",
    "mobile_number",
    "alternate_number",
    "alternate_phone",
    "email",
    "country_code",
    "country",
    "currency_code",
    "currency",
    "amount",
    "comment",
    "comments",
    "note",
    "notes",
    "purpose_of_account",
    "purpose",
    "state",
    "province",
    "zipcode",
    "zip",
    "postal_code",
    "postal",
    "account_number",
  ]);

  const isExactAccountNumberHeader = (header) =>
    String(header || "").replace(/^\uFEFF/, "") === "account_number";

  const getAccountKey = (row) => {
    const firstNameKey = Object.keys(row).find(
      (k) =>
        k.toLowerCase().includes("first") && k.toLowerCase().includes("name"),
    );
    const lastNameKey = Object.keys(row).find(
      (k) =>
        k.toLowerCase().includes("last") && k.toLowerCase().includes("name"),
    );
    const emailKey = Object.keys(row).find((k) =>
      k.toLowerCase().includes("email"),
    );
    const phoneKey = Object.keys(row).find(
      (k) =>
        k.toLowerCase().includes("phone") || k.toLowerCase().includes("mobile"),
    );

    const firstName = (firstNameKey ? row[firstNameKey] : "")
      .trim()
      .toLowerCase();
    const lastName = (lastNameKey ? row[lastNameKey] : "").trim().toLowerCase();
    const email = (emailKey ? row[emailKey] : "").trim().toLowerCase();
    const phone = (phoneKey ? row[phoneKey] : "").trim();

    const identifier = email || phone || "";
    return `${firstName}|${lastName}|${identifier}`;
  };

  const computeAccountTotals = (data) => {
    const accountTotals = new Map();

    data.forEach((row, index) => {
      const rowNum = index + 2;
      const amountKey = Object.keys(row).find((k) =>
        k.toLowerCase().includes("amount"),
      );
      const amount = parseFloat(amountKey ? row[amountKey] : 0) || 0;

      const firstNameKey = Object.keys(row).find(
        (k) =>
          k.toLowerCase().includes("first") && k.toLowerCase().includes("name"),
      );
      const lastNameKey = Object.keys(row).find(
        (k) =>
          k.toLowerCase().includes("last") && k.toLowerCase().includes("name"),
      );
      const firstName = (firstNameKey ? row[firstNameKey] : "").trim();
      const lastName = (lastNameKey ? row[lastNameKey] : "").trim();
      const displayName =
        [firstName, lastName].filter(Boolean).join(" ") || `Row ${rowNum}`;

      const key = getAccountKey(row);

      if (!accountTotals.has(key)) {
        accountTotals.set(key, { total: 0, rows: [], displayName });
      }
      const entry = accountTotals.get(key);
      entry.total += amount;
      entry.rows.push(rowNum);
    });

    return accountTotals;
  };

  const checkAccountCapsOnly = (data) => {
    const accountTotals = computeAccountTotals(data);
    const capErrors = [];

    accountTotals.forEach((entry) => {
      if (entry.total > MAX_AMOUNT_PER_ACCOUNT) {
        const rowLabel =
          entry.rows.length > 1
            ? `rows ${entry.rows.join(", ")}`
            : `row ${entry.rows[0]}`;
        capErrors.push({
          message:
            `"${entry.displayName}" (${rowLabel}): total $${entry.total.toFixed(2)} ` +
            `exceeds the $${MAX_AMOUNT_PER_ACCOUNT.toLocaleString()} per-account batch limit. ` +
            `Please split the excess into a separate batch file.`,
        });
      }
    });

    return capErrors;
  };

  const getPhoneEmailMismatchErrors = async (data) => {
    const contacts = data
      .map((row, index) => {
        const accountKey = Object.keys(row).find(isExactAccountNumberHeader);
        const phoneKey = Object.keys(row).find(
          (key) =>
            key.toLowerCase().includes("phone") ||
            key.toLowerCase().includes("mobile"),
        );
        const emailKey = Object.keys(row).find((key) =>
          key.toLowerCase().includes("email"),
        );
        return {
          rowNum: index + 2,
          accountno: accountKey ? String(row[accountKey] || "").trim() : "",
          phone: phoneKey ? String(row[phoneKey] || "").trim() : "",
          email: emailKey ? String(row[emailKey] || "").trim() : "",
        };
      })
      .filter(({ phone, email }) => phone && email);

    const phones = [...new Set(contacts.map(({ phone }) => phone))];
    if (phones.length === 0) return [];

    const results = await Promise.all(
      phones.map(async (phone) => {
        const response = await commonRunQuery(384, phone);
        if (
          !response?.data?.header ||
          String(response.data.header.callStatus) === "-1"
        ) {
          throw new Error("Unable to check whether the phone number has an existing account.");
        }

        // Query 384 returns phone_account_exists when the phone belongs to a phone-based account.
        const responseRecord = response?.data?.body?.record;
        const rawRecord =
          responseRecord?.b ?? responseRecord?.dir ?? responseRecord?.record ?? responseRecord;
        const records = Array.isArray(rawRecord)
          ? rawRecord
          : rawRecord
            ? [rawRecord]
            : [];
        return [phone, String(records[0]?.phone_account_exists || "") === "1"];
      }),
    );

    const phoneAccountExistsByPhone = new Map(results);
    return contacts
      .filter(({ phone }) => phoneAccountExistsByPhone.get(phone))
      .map(({ rowNum }) => ({
        message:
          `Row ${rowNum}: this phone number is already linked to an account. Please remove email from the batch record.`,
      }));
  };

  const getAccountContactMismatchErrors = async (data) => {
    const contacts = data
      .map((row, index) => {
        const accountKey = Object.keys(row).find(isExactAccountNumberHeader);
        const emailKey = Object.keys(row).find((key) =>
          key.toLowerCase().includes("email"),
        );
        const phoneKey = Object.keys(row).find(
          (key) =>
            key.toLowerCase().includes("phone") ||
            key.toLowerCase().includes("mobile"),
        );
        return {
          rowNum: index + 2,
          accountno: accountKey ? String(row[accountKey] || "").trim() : "",
          email: emailKey ? String(row[emailKey] || "").trim() : "",
          phone: phoneKey ? String(row[phoneKey] || "").trim() : "",
        };
      })
      // Account number remains optional. Rows without one do not use Query 385.
      .filter(({ accountno }) => accountno);

    const accountNumbers = [...new Set(contacts.map(({ accountno }) => accountno))];
    if (accountNumbers.length === 0) return [];

    const results = await Promise.all(
      accountNumbers.map(async (accountno) => {
        const response = await commonRunQuery(385, accountno);
        if (
          !response?.data?.header ||
          String(response.data.header.callStatus) === "-1"
        ) {
          throw new Error("Unable to retrieve the existing account details.");
        }

        // Query 385 returns the selected directory row as body.record.dir.
        const responseRecord = response?.data?.body?.record;
        const rawRecord =
          responseRecord?.b ?? responseRecord?.dir ?? responseRecord?.record ?? responseRecord;
        const records = Array.isArray(rawRecord)
          ? rawRecord
          : rawRecord
            ? [rawRecord]
            : [];
        return [accountno, records];
      }),
    );

    const recordsByAccount = new Map(results);
    const normalizeEmail = (value) => String(value || "").trim().toLowerCase();
    const normalizePhone = (value) => String(value || "").replace(/\D/g, "");

    return contacts.flatMap(({ rowNum, accountno, email, phone }) => {
      const records = recordsByAccount.get(accountno) || [];
      if (records.length === 0) {
        return [{
          message: `Row ${rowNum}: account number "${accountno}" was not found in the active account records.`,
        }];
      }
      if (records.length > 1) {
        return [{
          message: `Row ${rowNum}: account number "${accountno}" is linked to multiple active accounts. Please contact support.`,
        }];
      }

      const record = records[0];
      const accountEmail = normalizeEmail(record.emailAddress);
      const accountPhone = normalizePhone(record.phoneno);
      const suppliedPhone = normalizePhone(phone);
      const phoneMatches =
        !suppliedPhone ||
        (accountPhone
          ? accountPhone === suppliedPhone
          : accountEmail === `1${suppliedPhone}@4pay.ph`);
      const emailMatches = !email || normalizeEmail(email) === accountEmail;

      if (emailMatches && phoneMatches) return [];
      return [{
        message:
          `Row ${rowNum}: account number and contact details do not match the existing account information. ` +
          "Please correct the email or phone number and upload again.",
      }];
    });
  };

  const validateCsvData = (data) => {
    const rowErrors = {};

    const accountTotals = computeAccountTotals(data);
    const overLimitRows = new Map();

    accountTotals.forEach((entry) => {
      if (entry.total > MAX_AMOUNT_PER_ACCOUNT) {
        const rowLabel =
          entry.rows.length > 1
            ? `rows ${entry.rows.join(", ")}`
            : `row ${entry.rows[0]}`;
        entry.rows.forEach((rowNum) => {
          overLimitRows.set(
            rowNum,
            `Account "${entry.displayName}" total $${entry.total.toFixed(2)} across ${rowLabel} ` +
              `exceeds the $${MAX_AMOUNT_PER_ACCOUNT.toLocaleString()} per-account batch limit. ` +
              `Please split the excess into a separate batch file.`,
          );
        });
      }
    });

    data.forEach((row, index) => {
      const rowNum = index + 2;

      const firstNameKey = Object.keys(row).find(
        (key) =>
          (key.toLowerCase().includes("first") &&
            key.toLowerCase().includes("name")) ||
          key.toLowerCase() === "first_name",
      );
      const lastNameKey = Object.keys(row).find(
        (key) =>
          (key.toLowerCase().includes("last") &&
            key.toLowerCase().includes("name")) ||
          key.toLowerCase() === "last_name",
      );
      const first_name = firstNameKey ? (row[firstNameKey] || "").trim() : "";
      const last_name = lastNameKey ? (row[lastNameKey] || "").trim() : "";

      const currencyKey = Object.keys(row).find(
        (key) =>
          key.toLowerCase().includes("currency") ||
          key.toLowerCase() === "currency_code",
      );
      const currency_code = currencyKey ? (row[currencyKey] || "").trim() : "";

      const countryKey = Object.keys(row).find(
        (key) =>
          key.toLowerCase().includes("country") ||
          key.toLowerCase() === "country_code",
      );
      const country_code = countryKey ? (row[countryKey] || "").trim() : "";

      const purposeKey = Object.keys(row).find(
        (key) =>
          key.toLowerCase().includes("purpose") ||
          key.toLowerCase() === "purpose_of_account",
      );
      const purpose_of_account = purposeKey
        ? (row[purposeKey] || "").trim()
        : "" || "SALARY";

      const phoneKey = Object.keys(row).find(
        (key) =>
          key.toLowerCase().includes("phone") ||
          key.toLowerCase().includes("mobile") ||
          key.toLowerCase() === "phone_number" ||
          key.toLowerCase() === "alternate_number",
      );
      const phone_number = phoneKey ? (row[phoneKey] || "").trim() : "";

      const emailKey = Object.keys(row).find((key) =>
        key.toLowerCase().includes("email"),
      );
      const email = emailKey ? (row[emailKey] || "").trim() : "";

      const amountKey = Object.keys(row).find((key) =>
        key.toLowerCase().includes("amount"),
      );
      // const amount = amountKey ? (row[amountKey] || "").trim() : "";
      const amount = amountKey
        ? (row[amountKey] || "").toString().replace(/,/g, "").trim()
        : "";
      const accountNoKey = Object.keys(row).find(isExactAccountNumberHeader);
      const accountno = accountNoKey ? String(row[accountNoKey]).trim() : "";
      // const amount = amountKey
      //   ? (row[amountKey] || "").toString().replace(/,/g, "").trim()
      //   : "";

      const issues = [];

      if (!first_name) issues.push("First name is required");
      if (!last_name) issues.push("Last name is required");

      // The downstream AddTransFileRecs service accepts xs:integer only.
      // An empty value is sent as 0 for backwards compatibility, but a supplied
      // account number must be a whole number to avoid scheduling a batch that
      // cannot save its records.
      if (accountno && !/^\d+$/.test(accountno)) {
        issues.push("Account number must contain only whole-number digits");
      }

      if (!currency_code) {
        issues.push("Currency code is required (e.g. USD, CAD, TZS, PKR)");
      } else if (!VALID_CURRENCIES.has(currency_code)) {
        issues.push(
          `Unsupported currency code "${currency_code}". ` +
            `Allowed: ${Array.from(VALID_CURRENCIES).sort().join(", ")}`,
        );
      }

      if (!country_code) {
        issues.push(
          "Country code is required (3-letter code, e.g. CAN, USA, IND)",
        );
      } else {
        const normalized = country_code.toUpperCase().trim();
        if (normalized.length !== 3) {
          issues.push(
            `Country code must be exactly 3 characters (found: "${country_code}")`,
          );
        } else if (!VALID_COUNTRY_CODES.has(normalized)) {
          issues.push(
            `Invalid country code "${country_code}". ` +
              `Must be one of the supported 3-letter codes (e.g. CAN for Canada, USA, IND for India, GBR for UK)`,
          );
        }
      }

      //       if (!purpose_of_account) {
      //   issues.push("Purpose of account is required");
      // } else if (!/^\d+$/.test(purpose_of_account)) {
      //   issues.push("Purpose of account must contain only numeric values");
      // } else if (piIdsArr.size > 0 && !piIdsArr.has(purpose_of_account)) {
      //   // Only validate against the list if it has loaded
      //   const allowedList = Array.from(piIdsArr.entries())
      //     .map(([id, name]) => `${id} - ${name}`)
      //     .join(", ");
      //   issues.push(
      //     `Invalid purpose_of_account "${purpose_of_account}". Allowed values: ${allowedList}`,
      //   );
      // }
      if (!purpose_of_account) {
        issues.push("Purpose of account is required");
      } else if (!/^\d+$/.test(purpose_of_account)) {
        issues.push("Purpose of account must contain only numeric values");
      } else if (purpose_of_account !== "2") {
        issues.push(
          `Invalid purpose_of_account "${purpose_of_account}". Only value 2 is accepted.`,
        );
      }
      if (!phone_number && !email) {
        issues.push("Either phone number or email must be provided");
      }
      if (email && !isValidEmail(email)) {
        issues.push("Email must be in a valid format");
      }
      // if (amount !== "" && isNaN(parseFloat(amount))) {
      //   issues.push("Amount must be a valid number");
      // }
      // if (amount !== "" && parseFloat(amount) < 0) {
      //   issues.push("Amount must be greater than zero");
      // }
      if (amount !== "") {
        const numericAmount = parseFloat(amount);
        if (isNaN(numericAmount)) {
          issues.push(
            "Amount must be a valid number (digits and decimal point only, e.g. 1000.00)",
          );
        } else if (numericAmount < 0) {
          issues.push("Amount must be greater than or equal to zero");
        } else if (!/^\d+(\.\d{1,2})?$/.test(amount)) {
          issues.push(
            "Amount format invalid — use digits and a decimal point only (e.g. 1000.00), no commas or symbols",
          );
        }
      }
      if (phone_number && !/^\d+$/.test(phone_number)) {
        issues.push(
          "Phone number must contain only digits (no spaces or special characters).",
        );
      }
      if (overLimitRows.has(rowNum)) {
        issues.push(overLimitRows.get(rowNum));
      }

      if (issues.length > 0) {
        rowErrors[rowNum] = issues;
      }
    });

    return Object.keys(rowErrors).map((rowNum) => ({
      message: `Row ${rowNum} has these issues: ${rowErrors[rowNum].join(", ")}`,
    }));
  };

  // const checkDuplicatesInFile = (data) => {
  //   const seen = new Map();
  //   const errors = [];

  //   data.forEach((row, index) => {
  //     const rowNum = index + 2;
  //     const emailKey = Object.keys(row).find((k) =>
  //       k.toLowerCase().includes("email"),
  //     );
  //     const phoneKey = Object.keys(row).find(
  //       (k) =>
  //         k.toLowerCase().includes("phone") ||
  //         k.toLowerCase().includes("mobile"),
  //     );

  //     const email = emailKey ? (row[emailKey] || "").trim().toLowerCase() : "";
  //     const phone = phoneKey ? (row[phoneKey] || "").trim() : "";

  //     if (email) {
  //       if (seen.has(email)) {
  //         errors.push({
  //           message: `Row ${rowNum}: Duplicate email "${email}" — already used in row ${seen.get(email)}`,
  //         });
  //       } else {
  //         seen.set(email, rowNum);
  //       }
  //     }

  //     if (phone) {
  //       if (seen.has(phone)) {
  //         errors.push({
  //           message: `Row ${rowNum}: Duplicate phone "${phone}" — already used in row ${seen.get(phone)}`,
  //         });
  //       } else {
  //         seen.set(phone, rowNum);
  //       }
  //     }
  //   });

  //   return errors;
  // };
  // const checkDuplicatesInFile = (data) => {
  //   const seenEmails = new Map();
  //   const seenPhones = new Map();
  //   const errors = [];

  //   data.forEach((row, index) => {
  //     const rowNum = index + 2;
  //     const emailKey = Object.keys(row).find((k) =>
  //       k.toLowerCase().includes("email"),
  //     );
  //     const phoneKey = Object.keys(row).find(
  //       (k) =>
  //         k.toLowerCase().includes("phone") ||
  //         k.toLowerCase().includes("mobile"),
  //     );

  //     const email = emailKey ? (row[emailKey] || "").trim().toLowerCase() : "";
  //     const phone = phoneKey ? (row[phoneKey] || "").trim() : "";

  //     const hasBoth = email && phone;

  //     if (hasBoth) {
  //       // Only flag as duplicate if BOTH email AND phone were already seen together
  //       const emailSeenAt = seenEmails.get(email);
  //       const phoneSeenAt = seenPhones.get(phone);

  //       if (emailSeenAt !== undefined && phoneSeenAt !== undefined) {
  //         errors.push({
  //           message: `Row ${rowNum}: Duplicate record — email "${email}" already in row ${emailSeenAt} and phone "${phone}" already in row ${phoneSeenAt}`,
  //         });
  //       } else {
  //         // Only flag individual fields if they appeared in a row that also had both fields
  //         if (emailSeenAt !== undefined) {
  //           errors.push({
  //             message: `Row ${rowNum}: Duplicate email "${email}" — already used in row ${emailSeenAt}`,
  //           });
  //         }
  //         if (phoneSeenAt !== undefined && seenPhones.get(phone + "_hasBoth")) {
  //           // Phone is duplicated only if the prior row also had both fields (not phone-only)
  //           errors.push({
  //             message: `Row ${rowNum}: Duplicate phone "${phone}" — already used in row ${phoneSeenAt} (same email required to share a phone number)`,
  //           });
  //         }
  //         seenEmails.set(email, rowNum);
  //         seenPhones.set(phone, rowNum);
  //         seenPhones.set(phone + "_hasBoth", true);
  //       }
  //     } else {
  //       // Row has only email or only phone — flag straightforward duplicates
  //       if (email && seenEmails.has(email)) {
  //         errors.push({
  //           message: `Row ${rowNum}: Duplicate email "${email}" — already used in row ${seenEmails.get(email)}`,
  //         });
  //       } else if (email) {
  //         seenEmails.set(email, rowNum);
  //       }

  //       if (phone && seenPhones.has(phone)) {
  //         errors.push({
  //           message: `Row ${rowNum}: Duplicate phone "${phone}" — already used in row ${seenPhones.get(phone)}`,
  //         });
  //       } else if (phone) {
  //         seenPhones.set(phone, rowNum);
  //       }
  //     }
  //   });

  //   return errors;
  // };
  const checkDuplicatesInFile = (data) => {
    const seenEmails = new Map(); // email → rowNum
    const seenPhoneOnly = new Map(); // phone → rowNum (only for phone-only rows)

    const errors = [];

    data.forEach((row, index) => {
      const rowNum = index + 2;

      const emailKey = Object.keys(row).find((k) =>
        k.toLowerCase().includes("email"),
      );
      const phoneKey = Object.keys(row).find(
        (k) =>
          k.toLowerCase().includes("phone") ||
          k.toLowerCase().includes("mobile"),
      );

      const email = emailKey ? (row[emailKey] || "").trim().toLowerCase() : "";
      const phone = phoneKey ? (row[phoneKey] || "").trim() : "";

      const hasEmail = Boolean(email);
      const hasPhone = Boolean(phone);

      if (hasEmail && hasPhone) {
        // Both present: only email must be unique; phone can be shared
        if (seenEmails.has(email)) {
          errors.push({
            message: `Row ${rowNum}: Duplicate email "${email}" — already used in row ${seenEmails.get(email)}`,
          });
        } else {
          seenEmails.set(email, rowNum);
        }
        // Phone is intentionally NOT checked here — sharing a phone across
        // different emails is explicitly allowed.
      } else if (hasEmail) {
        // Email only: email must be unique
        if (seenEmails.has(email)) {
          errors.push({
            message: `Row ${rowNum}: Duplicate email "${email}" — already used in row ${seenEmails.get(email)}`,
          });
        } else {
          seenEmails.set(email, rowNum);
        }
      } else if (hasPhone) {
        // Phone only: phone must be unique among phone-only rows
        if (seenPhoneOnly.has(phone)) {
          errors.push({
            message: `Row ${rowNum}: Duplicate phone "${phone}" — already used in row ${seenPhoneOnly.get(phone)}`,
          });
        } else {
          seenPhoneOnly.set(phone, rowNum);
        }
      }
    });

    return errors;
  };
  const buildValidationPayload = (data) => {
    const records = data.map((row, index) => {
      const emailKey = Object.keys(row).find((k) =>
        k.toLowerCase().includes("email"),
      );
      const phoneKey = Object.keys(row).find(
        (k) =>
          k.toLowerCase().includes("phone") ||
          k.toLowerCase().includes("mobile"),
      );
      const countryKey = Object.keys(row).find((k) =>
        k.toLowerCase().includes("country"),
      );
      const purposeKey = Object.keys(row).find((k) =>
        k.toLowerCase().includes("purpose"),
      );
      const accountNoKey = Object.keys(row).find(isExactAccountNumberHeader);
      const email = emailKey ? (row[emailKey] || "").trim() : "";
      const phone = phoneKey ? (row[phoneKey] || "").trim() : "";
      const country = countryKey ? (row[countryKey] || "").trim() : "";
      const purpose = purposeKey ? (row[purposeKey] || "").trim() : "";
      const accountno = accountNoKey ? String(row[accountNoKey]).trim() : "";
      return {
        useremail: email || phone,
        accountno,
        country: country,
        purposeofaccount: purpose ? Number(purpose) : 2,
        rowId: String(index + 2),
      };
    });
    return records;
  };

  const handleDownloadTemplate = () => {
    const wb = XLSX.utils.book_new();

    const headers = [
      "first_name",
      "last_name",
      "birthdate",
      "account_number",
      "address",
      "phone_number",
      "alternate_number",
      "email",
      "country_code",
      "currency_code",
      "amount",
      "comment",
      "purpose_of_account",
    ];

    const exampleRows = [
      [
        "John",
        "Doe",
        "1990-01-15",
        "1234567890",
        "123 Main St Apt 4B",
        "6471234567",
        "",
        "john.doe@4pay.ca",
        "TCA",
        "USD",
        "0.00",
        "Monthly salary",
        "2",
      ],
    ];

    const wsData = [headers, ...exampleRows];
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    ws["!cols"] = [
      { wch: 16 },
      { wch: 16 },
      { wch: 14 },
      { wch: 14 },
      { wch: 26 },
      { wch: 20 },
      { wch: 20 },
      { wch: 26 },
      { wch: 14 },
      { wch: 14 },
      { wch: 12 },
      { wch: 22 },
      { wch: 20 },
    ];

    XLSX.utils.book_append_sheet(wb, ws, "Payroll Data");
    XLSX.writeFile(wb, "batch_payroll_template.xlsx");

    setAlert({
      open: true,
      severity: "success",
      header: "Template Downloaded",
      message:
        "batch_payroll_template.xlsx downloaded. Fill it in Excel, save as CSV, then upload!",
    });
  };

  useEffect(() => {
    const now = new Date();
    const localTime = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 16);
    setSelectedDateTime(localTime);
    getListOfPis();
  }, []);

  useEffect(() => {
    const payrollBatch = batchList.find(
      (b) => b.batchfilecategories.categoryid === PAYROLL_CATEGORY_ID,
    );
    if (payrollBatch) {
      setUploadLocation(payrollBatch.batchfilecategories.uploadlocation);
    }
  }, [batchList]);

  useEffect(() => {
    if (csvData.length > 0) {
      const total = csvData.reduce((sum, row) => {
        const amountKey = Object.keys(row).find((k) =>
          k.toLowerCase().includes("amount"),
        );
        const amt = amountKey ? parseFloat(row[amountKey] || 0) : 0;
        return sum + (isNaN(amt) ? 0 : amt);
      }, 0);
      setTotalAmount(total.toFixed(2));
    } else {
      setTotalAmount("0.00");
    }
  }, [csvData]);

  const getListOfPis = async () => {
    try {
      const response = await commonRunQuery(112, "");
      if (response?.data?.header?.callStatus == "1") {
        const responseData = setAsArray(response?.data?.body?.record);
        const PURPOSE_MAP = new Map(
          responseData.map((item) => [
            item.pipurpose.typeID,
            item.pipurpose.name,
          ]),
        );
        setPiIdsArr(PURPOSE_MAP);
      }
    } catch (error) {
      console.log("getListOfPis_error---------", error);
    }
  };

  const handleFileChange = async (event) => {
    const file = event.target.files?.[0];
    if (!file) {
      event.target.value = "";
      return;
    }

    const ext = file.name.split(".").pop()?.toLowerCase();
    if (!["csv", "zip"].includes(ext)) {
      setAlert({
        open: true,
        severity: "error",
        header: "Invalid File",
        message: "Only .csv and .zip files are allowed.",
      });
      event.target.value = "";
      setOriginalFileName("");
      return;
    }

    setIsParsing(true);
    setOriginalFileName(file.name);
    setFileName("");
    setDisplayedFileName(`Processing ${file.name}...`);
    setValidationErrors([]);
    // setCustomerIdByRow({});
    setTotalAmount("0.00");

    const sanitizedCompany = companyName.replace(/[^a-zA-Z0-9]/g, "_");
    const dateStr = new Date().toISOString().slice(0, 10).replace(/-/g, "");
    const baseName = file.name.replace(/\.[^/.]+$/, "");
    const newFileName = `Payroll_${baseName}_${sanitizedCompany}_${dateStr}.csv`;
    const normalizedFileNameForCheck = file.name.replace(/(\.csv)+$/i, ".csv");
    // ── Duplicate-file check (ScheduleJobList5) ──────────────────────────
    // callStatus === "1" means a matching record WAS found → block upload.
    // Anything else (e.g. "0" / "Could not find scheduled items") → proceed.
    try {
const dupCheckResponse = await ScheduleJobList6({
  location: "",
  rows: 0,
  requestid: 0,
  userid: 0,
  categoryid: 0,
  executionstatus: "",
  originalfilename: normalizedFileNameForCheck,
});

      if (dupCheckResponse?.data?.header?.callStatus === "1") {
        setAlert({
          open: true,
          severity: "error",
          header: "File Already Exists",
          message: `Please rename the file or check existing batches before re-uploading.`,
        });
        setIsParsing(false);
        setOriginalFileName("");
        setDisplayedFileName("");
        setFileName("");
        if (fileInputRef.current) fileInputRef.current.value = "";
        return;
      }
    } catch (dupErr) {
      console.error("ScheduleJobList5 duplicate check failed:", dupErr);
    }

    setDisplayedFileName(`Processing ${file.name}...`);

    // const formData = new FormData();
    // formData.append("file", file, newFileName);
    const detectedEncodingEarly = await detectFileEncoding(file);
    const fileToUpload =
      detectedEncodingEarly === "windows-1252"
        ? await reencodeToUtf8(file)
        : file;

    const formData = new FormData();
    formData.append("file", fileToUpload, newFileName);
    try {
      const endpoint =
        ext === "zip" ? "/uploadbatch_zip.php" : "/uploadbatch.php";
      const response = await fetch(getBaseUrl(serviceUrl) + endpoint, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) throw new Error(`Upload failed: ${response.status}`);

      const result = await response.json();
      const uploadedFileName = result.newfilename || newFileName;
      setFileName(uploadedFileName);
      const batchMatch = uploadedFileName.match(/BATCH_?-?\d+/i);
      const batchPrefix = batchMatch ? batchMatch[0].replace("_-", "-") : "";

      const displayCompanyClean = companyName.replace(/[^a-zA-Z0-9'\s]/g, "_");
      const displayFileName = `${batchPrefix}_Payroll_${baseName}_${displayCompanyClean}_${dateStr}.csv`;
      setDisplayedFileName(displayFileName);

      if (ext === "zip") {
        setCsvData([]);
        setIsParsing(false);
        setAlert({
          open: true,
          severity: "success",
          header: "ZIP Uploaded",
          message: "ZIP file successfully uploaded and ready for scheduling.",
        });
        return;
      }
      // ── Auto-detect encoding before parsing ──────────────────────────────
      const detectedEncoding = detectedEncodingEarly;
      console.log(
        `[Encoding] Detected: ${detectedEncoding} for file: ${file.name}`,
      );
      const fileForParsing = fileToUpload;
      Papa.parse(fileForParsing, {
        header: true,
        skipEmptyLines: true,
        encoding: detectedEncoding,
        complete: async (res) => {
          const actualHeaders = res.meta.fields || [];

          if (!actualHeaders.some(isExactAccountNumberHeader)) {
            setAlert({
              open: true,
              severity: "error",
              header: "Invalid Payroll Template",
              message:
                "The account-number column must be named exactly account_number. Please download and use the latest payroll template.",
            });
            setCsvData([]);
            setIsParsing(false);
            setFileName("");
            setDisplayedFileName("");
            setOriginalFileName("");
            if (fileInputRef.current) fileInputRef.current.value = "";
            return;
          }

          const unexpected = actualHeaders.filter((h) => {
            const norm = getNormalizedHeader(h);
            return (
              !ALLOWED_COLUMNS.has(norm) ||
              (norm === "account_number" && !isExactAccountNumberHeader(h))
            );
          });

          if (unexpected.length > 0) {
            setAlert({
              open: true,
              severity: "error",
              header: "Invalid Columns",
              message: `Found unsupported column(s):\n• ${unexpected.join("\n• ")}\n\nPlease use only columns from the template.`,
            });
            setCsvData([]);
            setIsParsing(false);
            setFileName("");
            setDisplayedFileName("");
            setOriginalFileName("");
            if (fileInputRef.current) fileInputRef.current.value = "";
            return;
          }

          let rawData = res.data.filter((row) =>
            Object.values(row).some((v) => v && String(v).trim() !== ""),
          );

          // rawData = rawData.map((row, index) => {
          //   const newRow = { ...row };
          //   const birthKey = Object.keys(row).find(
          //     (k) =>
          //       k.toLowerCase().includes("birth") ||
          //       k.toLowerCase().includes("dob"),
          //   );
          //   if (birthKey && newRow[birthKey]) {
          //     const originalDate = newRow[birthKey];
          //     const normalizedDate = normalizeBirthdate(originalDate);
          //     console.log(
          //       `Row ${index + 2} | Original: "${originalDate}" → Normalized: "${normalizedDate}"`,
          //     );
          //     newRow[birthKey] = normalizedDate;
          //   }
          //   return newRow;
          // });
          rawData = rawData.map((row, index) => {
            // Sanitize every cell first
            const newRow = Object.fromEntries(
              Object.entries(row).map(([k, v]) => [k, sanitizeCell(v)]),
            );

            // Then normalize birthdate on the already-sanitized value
            const birthKey = Object.keys(newRow).find(
              (k) =>
                k.toLowerCase().includes("birth") ||
                k.toLowerCase().includes("dob"),
            );
            if (birthKey && newRow[birthKey]) {
              const originalDate = newRow[birthKey];
              const normalizedDate = normalizeBirthdate(originalDate);
              console.log(
                `Row ${index + 2} | Original: "${originalDate}" → Normalized: "${normalizedDate}"`,
              );
              newRow[birthKey] = normalizedDate;
            }
            return newRow;
          });
          setCsvData(rawData);

          const total = rawData.reduce((sum, row) => {
            const amtKey = Object.keys(row).find((k) =>
              k.toLowerCase().includes("amount"),
            );
            const amt = amtKey ? parseFloat(row[amtKey] || 0) : 0;
            return sum + (isNaN(amt) ? 0 : amt);
          }, 0);
          setTotalAmount(total.toFixed(2));

          const errors = validateCsvData(rawData);
          const capErrors = checkAccountCapsOnly(rawData);

          if (errors.length === 0 && capErrors.length === 0) {
            try {
              errors.push(...(await getPhoneEmailMismatchErrors(rawData)));
            } catch (error) {
              console.error("Phone-account lookup failed:", error);
              errors.push({
                message:
                  "Could not verify the existing phone account details. Please try uploading the file again.",
              });
            }
            try {
              errors.push(...(await getAccountContactMismatchErrors(rawData)));
            } catch (error) {
              console.error("Account-contact lookup failed:", error);
              errors.push({
                message:
                  "Could not verify the existing account details. Please try uploading the file again.",
              });
            }
          }

          setValidationErrors(errors);
          setIsParsing(false);

          if (capErrors.length > 0) {
            setAlert({
              open: true,
              severity: "error",
              header: `Per-Account Limit Exceeded ($${MAX_AMOUNT_PER_ACCOUNT.toLocaleString()} max per batch)`,
              message:
                capErrors.map((e) => `• ${e.message}`).join("\n") +
                `\n\nUsers needing to credit more than $${MAX_AMOUNT_PER_ACCOUNT.toLocaleString()} ` +
                `to the same account must upload a separate batch file for the additional amount.`,
            });
            return;
          }

          if (errors.length > 0) {
            setAlert({
              open: true,
              severity: "warning",
              header: `${errors.length} Issue${errors.length === 1 ? "" : "s"} Found`,
              message:
                "Please review and fix the validation issues before scheduling.",
            });
            return;
          }

          if (rawData.length === 0) {
            setAlert({
              open: true,
              severity: "info",
              header: "Empty File",
              message: "File uploaded but no valid records were found.",
            });
            return;
          }

          const duplicateErrors = checkDuplicatesInFile(rawData);
          if (duplicateErrors.length > 0) {
            console.log(
              "[Duplicate Check] Found duplicates in file:",
              duplicateErrors,
            );
            setValidationErrors(duplicateErrors);
            setAlert({
              open: true,
              severity: "error",
              header: `${duplicateErrors.length} Duplicate(s) Found in File`,
              message:
                "Each employee must appear only once per batch (unique email/phone). " +
                "Please fix duplicates before uploading.",
            });
            return;
          }

          console.log("[Duplicate Check] No duplicates found ✓");

          try {
            const payload = buildValidationPayload(rawData);

            console.log(
              "[ValidatePayrollFileRecords] Sending payload →",
              payload,
            );

            const apiResponse = await ValidatePayrollFileRecords(payload);

            console.log(
              "[ValidatePayrollFileRecords] Raw API response →",
              apiResponse,
            );

            if (apiResponse?.data?.header?.callStatus === "1") {
              // const bodyString = apiResponse.data.body.replace(/&quot;/g, '"');
              // const validatedRecords = JSON.parse(bodyString);
              const bodyString = apiResponse.data.body
                .replace(/&quot;/g, '"')
                .replace(/&amp;/g, "&")
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">")
                .replace(/[\u0000-\u001F\u007F]/g, " ") // strip control chars that break JSON
                .trim();
              // ← ADD THIS GUARD
              if (!bodyString || bodyString.length < 2) {
                console.error(
                  "[ValidatePayrollFileRecords] Server returned empty body — likely invalid UTF-8 in a cell value",
                );
                setAlert({
                  open: true,
                  severity: "error",
                  header: "File Contains Unsupported Characters",
                  message:
                    "One or more cells in your file contain special characters that cannot be processed. " +
                    "Please open the file in Excel, check for unusual characters (especially in names), save as CSV (UTF-8), and re-upload.",
                });
                setIsParsing(false);
                return;
              }
              let validatedRecords;
              try {
                validatedRecords = JSON.parse(bodyString);
              } catch (parseErr) {
                console.error(
                  "[ValidatePayrollFileRecords] JSON parse failed →",
                  parseErr,
                  "\nRaw body →",
                  bodyString,
                );
                setAlert({
                  open: true,
                  severity: "error",
                  header: "Validation Response Error",
                  message:
                    "Server returned an unreadable response. Please try again or contact support.",
                });
                setIsParsing(false);
                return;
              }
              console.log(
                "[ValidatePayrollFileRecords] Parsed records:",
                validatedRecords,
              );

              const apiErrors = validatedRecords
                .filter((record) => record.error === 1)
                .map((record) => ({
                  message: `Employee ${Number(record.rowId) - 1} (Row ${record.rowId}): ${record.errormessage}`,
                }));

              if (apiErrors.length > 0) {
                setValidationErrors(apiErrors);
                setAlert({
                  open: true,
                  severity: "error",
                  header: `${apiErrors.length} Issue(s) Found`,
                  message: "Please fix the errors before scheduling.",
                });
                return;
              }
              // const resolvedCustomerIds = validatedRecords.reduce(
              //   (result, record) => {
              //     const customerId = Number(record.customerid);

              //     if (Number.isInteger(customerId) && customerId > 0) {
              //       result[String(record.rowId)] = customerId;
              //     }

              //     return result;
              //   },
              //   {},
              // );
              // setCustomerIdByRow(resolvedCustomerIds);
            } else {
              console.error(
                "[ValidatePayrollFileRecords] API error:",
                apiResponse,
              );
              setAlert({
                open: true,
                severity: "error",
                header: "Validation Failed",
                message: "Could not validate records. Please try again.",
              });
              return;
            }
          } catch (apiErr) {
            console.error(
              "[ValidatePayrollFileRecords] API call failed →",
              apiErr,
            );
            setAlert({
              open: true,
              severity: "error",
              header: "Validation Error",
              message: "Could not reach validation service. Please try again.",
            });
            return;
          }

          setAlert({ open: false });
        },

        error: (err) => {
          console.error("PapaParse error:", err);
          setAlert({
            open: true,
            severity: "error",
            header: "File Read Error",
            message: "Could not parse the CSV file.",
          });
          setIsParsing(false);
          setCsvData([]);
          setFileName("");
          setDisplayedFileName("");
          setOriginalFileName("");
          if (fileInputRef.current) fileInputRef.current.value = "";
        },
      });
    } catch (err) {
      console.error("Upload error:", err);
      setAlert({
        open: true,
        severity: "error",
        header: "Upload Failed",
        message: err.message || "Could not upload the file.",
      });
      setIsParsing(false);
      setFileName("");
      setDisplayedFileName("");
      setOriginalFileName("");
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  };

  const submitBatch = async (PIN) => {
    if (isSubmittingRef.current) {
      console.warn("submitBatch already in progress — ignoring duplicate call");
      return;
    }
    isSubmittingRef.current = true;
    setPinProcessing(true);
    setSuccessfulSchedule(false);
    // setShowPinPad(false);

    const totalRecords = fileName.toLowerCase().endsWith(".zip")
      ? 1
      : csvData.length;

    setUploadProgress({
      isUploading: true,
      processed: 0,
      total: totalRecords,
      message: "Scheduling batch...",
    });

    try {
      const enhancedNotes = notes || "";

      // const scheduleResponse = await ScheduleEntryAdd3(
      //   merchantInfo.id,
      //   selectedDateTime,
      //   fileName,
      //   uploadLocation,
      //   PAYROLL_CATEGORY_ID,
      //   totalRecords,
      //   enhancedNotes,
      //   PIN,
      //   parseFloat(totalAmount) || 0,
      //   merchantInfo.id,
      //   0,
      //   merchantInfo.id,
      // );
      const scheduleResponse = await Promise.race([
        ScheduleEntryAdd3(
          merchantInfo.id,
          selectedDateTime,
          fileName,
          uploadLocation,
          PAYROLL_CATEGORY_ID,
          totalRecords,
          enhancedNotes,
          PIN,
          parseFloat(totalAmount) || 0,
          merchantInfo.id,
          0,
          merchantInfo.id,
          originalFileName || fileName,
        ),
        new Promise((_, reject) =>
          setTimeout(() => reject(new Error("REQUEST_TIMEOUT")), 20000),
        ),
      ]);
      if (scheduleResponse.callStatus !== "1") {
        if (
          scheduleResponse?.payload?.msg?.toLowerCase().includes("pin") ||
          scheduleResponse?.payload?.msg
            ?.toLowerCase()
            .includes("invalid pin") ||
          scheduleResponse?.payload?.msg
            ?.toLowerCase()
            .includes("incorrect pin") ||
          (scheduleResponse?.payload?.callStatus === "0" &&
            scheduleResponse?.payload?.msg?.includes("authentication"))
        ) {
          throw new Error("INCORRECT_PIN");
        }
        throw new Error("Failed to schedule batch");
      }
      setShowPinPad(false);
      const requestid = scheduleResponse.requestid;

      setUploadProgress((prev) => ({
        ...prev,
        message: "Batch scheduled! Saving records...",
      }));

      let successCount = 0;
      let failCount = 0;
      const failedRecords = [];

      if (!fileName.toLowerCase().endsWith(".zip") && csvData.length > 0) {
        for (let i = 0; i < csvData.length; i++) {
          const row = csvData[i];

          const firstNameKey = Object.keys(row).find(
            (k) =>
              k.toLowerCase().includes("first") &&
              k.toLowerCase().includes("name"),
          );
          const lastNameKey = Object.keys(row).find(
            (k) =>
              k.toLowerCase().includes("last") &&
              k.toLowerCase().includes("name"),
          );
          const amountKey = Object.keys(row).find((k) =>
            k.toLowerCase().includes("amount"),
          );
          const emailKey = Object.keys(row).find((k) =>
            k.toLowerCase().includes("email"),
          );
          const phoneKey = Object.keys(row).find(
            (k) =>
              k.toLowerCase().includes("phone") ||
              k.toLowerCase().includes("mobile"),
          );
          const currencyKey = Object.keys(row).find((k) =>
            k.toLowerCase().includes("currency"),
          );
          const countryKey = Object.keys(row).find((k) =>
            k.toLowerCase().includes("country"),
          );
          const purposeKey = Object.keys(row).find((k) =>
            k.toLowerCase().includes("purpose"),
          );
          const birthdateKey = Object.keys(row).find(
            (k) =>
              k.toLowerCase().includes("birth") ||
              k.toLowerCase().includes("dob"),
          );
          const address1Key = Object.keys(row).find(
            (k) =>
              k.toLowerCase().includes("address") &&
              !k.toLowerCase().includes("2"),
          );
          const address2Key = Object.keys(row).find(
            (k) =>
              k.toLowerCase().includes("address2") ||
              k.toLowerCase().includes("address 2"),
          );
          const stateKey = Object.keys(row).find(
            (k) =>
              k.toLowerCase().includes("state") ||
              k.toLowerCase().includes("province"),
          );
          const zipKey = Object.keys(row).find(
            (k) =>
              k.toLowerCase().includes("zip") ||
              k.toLowerCase().includes("postal"),
          );
          const commentKey = Object.keys(row).find(
            (k) =>
              k.toLowerCase().includes("comment") ||
              k.toLowerCase().includes("note"),
          );
          const accountNoKey = Object.keys(row).find(
            isExactAccountNumberHeader,
          );

          const accountno = accountNoKey
            ? String(row[accountNoKey]).trim()
            : "";
          // const customerid = customerIdByRow[String(i + 2)] || 0;
          const payload = {
            requestid,
            userid: merchantInfo.id,
            // customerid, // Employee/customer ID
            accountno, // Employee account number
            firstname: firstNameKey ? (row[firstNameKey] || "").trim() : "",
            lastname: lastNameKey ? (row[lastNameKey] || "").trim() : "",
            birthdate: birthdateKey ? (row[birthdateKey] || "").trim() : "",
            address1: address1Key ? (row[address1Key] || "").trim() : "",
            address2: address2Key ? (row[address2Key] || "").trim() : "",
            country: countryKey ? (row[countryKey] || "").trim() : "CA",
            state: stateKey ? (row[stateKey] || "").trim() : "",
            zipcode: zipKey ? (row[zipKey] || "").trim() : "",
            phoneno: phoneKey ? (row[phoneKey] || "").trim() : "",
            phoneno2: "",
            email: emailKey ? (row[emailKey] || "").trim() : "",
            currency: currencyKey ? (row[currencyKey] || "").trim() : "CAD",
            // amount: amountKey ? (row[amountKey] || "").trim() : "0",
            amount: amountKey
              ? (row[amountKey] || "").toString().replace(/,/g, "").trim() ||
                "0"
              : "0",
            comment: commentKey
              ? (decodeHtmlEntities(row[commentKey]) || "").trim()
              : "",
            purposeofaccount: purposeKey
              ? (row[purposeKey] || "").trim()
              : "SALARY",
            status: "Pending",
            errormessage: "",
          };

          try {
            const result = await AddTransFileRecs(payload);
            if (String(result?.callStatus) === "1") {
              successCount++;
            } else {
              failCount++;
              const serviceError =
                result?.payload?.msg ||
                result?.payload?.message ||
                result?.msg ||
                "The record was not accepted by the payroll service.";
              failedRecords.push({
                row: i + 2,
                message: decodeHtmlEntities(String(serviceError))
                  .replace(/<[^>]*>/g, " ")
                  .replace(/\s+/g, " ")
                  .trim(),
              });
            }
          } catch (err) {
            failCount++;
            failedRecords.push({
              row: i + 2,
              message:
                err?.response?.data?.payload?.msg ||
                err?.message ||
                "The record could not be saved.",
            });
          }

          setUploadProgress({
            isUploading: true,
            processed: i + 1,
            total: totalRecords,
            message: `Saving records... ${i + 1}/${totalRecords}`,
          });
        }
      }

      if (failCount > 0) {
        setValidationErrors(
          failedRecords.map((record) => ({
            message: `Row ${record.row}: ${record.message}`,
          })),
        );
        setAlert({
          open: true,
          severity: "error",
          header: "Payroll Records Could Not Be Saved",
          message:
            `Request ID: ${requestid}\n${successCount} saved, ${failCount} failed. ` +
            "The batch was scheduled, but it is incomplete. Fix the listed records before continuing.",
        });
        setSuccessfulSchedule(false);
        setUploadProgress({ isUploading: false, processed: 0, total: 0, message: "" });
        return;
      }

      setAlert({
        open: true,
        severity: "success",
        header: "Payroll Submitted!",
        message: `Request ID: ${requestid}\n${successCount} saved, ${failCount} failed.`,
      });

      setSuccessfulSchedule(true);

      setTimeout(() => {
        setFileName("");
        setOriginalFileName("");
        setCsvData([]);
        // setCustomerIdByRow({});
        setDisplayedFileName("");
        setNotes("");
        setSuccessfulSchedule(false);
        setUploadProgress({
          isUploading: false,
          processed: 0,
          total: 0,
          message: "",
        });
      }, 5000);
    } catch (error) {
      if (error.message === "REQUEST_TIMEOUT") {
        setAlert({
          open: true,
          severity: "error",
          header: "Request Timed Out",
          message:
            "We didn't hear back from the server in time. Please check if the batch was scheduled before retrying, to avoid duplicate submission.",
        });
      }
      if (error.message === "INCORRECT_PIN") {
        setAlert({
          open: true,
          severity: "error",
          header: "Incorrect PIN",
          message: "The PIN you entered is wrong. Please try again.",
        });
      } else {
        setAlert({
          open: true,
          severity: "error",
          header: "Upload Failed",
          message: error.message || "Something went wrong.",
        });
      }
      setUploadProgress({ isUploading: false });
    } finally {
      isSubmittingRef.current = false;
      setPinProcessing(false); //  ab agla legit submit allow hoga
    }
  };

  const handlePinConfirm = (event, pinArray) => {
    const PIN = pinArray.join("");
    submitBatch(PIN);
  };

  const handleScheduleClick = () => {
    if (!fileName) {
      setAlert({
        open: true,
        severity: "error",
        header: "Error",
        message: "Please upload a file first.",
      });
      return;
    }

    const totalRecords = fileName.toLowerCase().endsWith(".zip")
      ? 1
      : csvData.length;

    if (totalRecords === 0) {
      setAlert({
        open: true,
        severity: "error",
        header: "Cannot Schedule",
        message: "This batch has 0 records. Please upload a file with data.",
      });
      return;
    }

    const capErrors = checkAccountCapsOnly(csvData);
    if (capErrors.length > 0) {
      setAlert({
        open: true,
        severity: "error",
        header: `Cannot Schedule — Per-Account Limit Exceeded ($${MAX_AMOUNT_PER_ACCOUNT.toLocaleString()} max per batch)`,
        message:
          capErrors.map((e) => `• ${e.message}`).join("\n") +
          `\n\nUsers needing to credit more than $${MAX_AMOUNT_PER_ACCOUNT.toLocaleString()} ` +
          `to the same account must upload a separate batch file for the additional amount.`,
      });
      return;
    }

    const errors = validateCsvData(csvData);
    setValidationErrors(errors);

    if (errors.length > 0) {
      const firstFive = errors.slice(0, 5);
      const remaining = errors.length - 5;
      const messageLines = firstFive.map((e) => `• ${e.message}`).join("\n");
      const finalMessage =
        remaining > 0
          ? `${messageLines}\n• ... and ${remaining} more issue(s).`
          : messageLines;

      setAlert({
        open: true,
        severity: "error",
        header: "Cannot Schedule Payroll",
        message: `Please fix the ${errors.length} validation issue(s) in the file:\n${finalMessage}`,
      });
      return;
    }

    const duplicateErrors = checkDuplicatesInFile(csvData);
    if (duplicateErrors.length > 0) {
      console.log(
        "[Submit — Duplicate Check] Duplicates found:",
        duplicateErrors,
      );
      setValidationErrors(duplicateErrors);
      setAlert({
        open: true,
        severity: "error",
        header: "Duplicate Records Found",
        message: `${duplicateErrors.length} duplicate email/phone found. Please fix before submitting.`,
      });
      return;
    }

    setShowPinPad(true);
  };

  return (
    <Box className="schedule-payroll-container">
      <Typography
        variant="h5"
        sx={{ mb: 1, color: "#5523D2", fontWeight: "bold" }}
      >
        Bulk Payroll Upload
      </Typography>

      <Typography
        variant="h6"
        sx={{ mb: 3, color: "#1e293b", fontWeight: 500 }}
      >
        Company: <strong>{companyName}</strong>
      </Typography>

      <Box className="scheduler-row">
        <Box className="input-group">
          <label>Schedule Date &amp; Time</label>
          <input
            type="datetime-local"
            className="batch-date"
            value={selectedDateTime}
            onChange={(e) => setSelectedDateTime(e.target.value)}
          />
        </Box>
      </Box>

      <Box className="upload-section">
        <Box className="input-group">
          <label>
            Upload Payroll File (CSV or ZIP)
            <br />
            {displayedFileName ? (
              <Button
                variant="outlined"
                size="small"
                onClick={() => {
                  if (fileInputRef.current) {
                    fileInputRef.current.value = "";
                    fileInputRef.current.click();
                  }
                }}
                sx={{ mt: 1, borderColor: "#5523D2", color: "#5523D2" }}
              >
                Change File
              </Button>
            ) : null}
            <Button
              variant="outlined"
              color="primary"
              size="small"
              startIcon={<DownloadIcon />}
              onClick={handleDownloadTemplate}
              sx={{
                mt: 1,
                borderColor: "#5523D2",
                color: "#5523D2",
                fontSize: "0.85rem",
              }}
            >
              Download Template (Excel)
            </Button>
            <span className="template-update-notice" role="status">
              <InfoOutlinedIcon fontSize="small" aria-hidden="true" />
              Please use the latest template (includes the Account Number column).
            </span>
          </label>

          <input
            type="file"
            accept=".csv,.zip"
            ref={fileInputRef}
            onChange={handleFileChange}
            style={{
              display: displayedFileName ? "none" : "block",
              color: "transparent",
            }}
          />
        </Box>

        <Box className="input-group">
          <label>File Notes (Optional)</label>
          <input
            type="text"
            placeholder="Add notes..."
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </Box>
      </Box>

      <Box
        sx={{
          mt: 1.5,
          mb: 1,
          px: 2,
          py: 1.5,
          backgroundColor: "#E6F1FB",
          border: "0.5px solid #B5D4F4",
          borderRadius: 2,
          display: "flex",
          gap: 1,
          alignItems: "flex-start",
        }}
      >
        <InfoOutlinedIcon
          sx={{ fontSize: 16, color: "#185FA5", mt: "2px", flexShrink: 0 }}
        />
        <Box>
          <Typography
            sx={{ fontSize: 13, fontWeight: 500, color: "#0C447C", mb: 0.25 }}
          >
            How to prepare your file
          </Typography>
          <Box
            component="ol"
            sx={{
              fontSize: 13,
              color: "#185FA5",
              m: 0,
              pl: 2,
              lineHeight: 1.8,
            }}
          >
            <li>Download the batch template above</li>
            <li>
              Open it in <strong>Microsoft Excel</strong>
            </li>
            <li>Fill in your employee and payroll data</li>
            <li>
              Save / export as <strong>.csv format</strong> before uploading
            </li>
            <li>
              <strong>Limit:</strong> No single account may receive more than{" "}
              <strong>${MAX_AMOUNT_PER_ACCOUNT.toLocaleString()}</strong> within
              one batch file. Split larger amounts across separate batch
              uploads.
            </li>
          </Box>
        </Box>
      </Box>

      {originalFileName && (
        <Box className="file-status">
          Selected: {cleanFileName(originalFileName)}
        </Box>
      )}
      {displayedFileName && validationErrors.length <= 0 && (
        <Box
          className="file-status"
          sx={{ color: "green", fontWeight: "bold" }}
        >
          Ready: {cleanFileName(displayedFileName)}
        </Box>
      )}

      {fileName && !fileName.toLowerCase().endsWith(".zip") && (
        <>
          {isParsing ? (
            <Box
              sx={{
                my: 4,
                p: 4,
                textAlign: "center",
                bgcolor: "#f8f9fa",
                borderRadius: 2,
                border: "1px dashed #5523D2",
              }}
            >
              <CircularProgress size={40} sx={{ color: "#5523D2", mb: 2 }} />
              <Typography variant="h6" color="#5523D2">
                Processing CSV file...
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                Reading, validating and preparing records
              </Typography>
            </Box>
          ) : csvData.length === 0 ? (
            <Box
              sx={{
                my: 3,
                p: 3,
                bgcolor: "#fff3cd",
                border: "1px solid #ffeaa7",
                borderRadius: 2,
              }}
            >
              <Typography variant="h6" color="#856404">
                No Valid Records Found
              </Typography>
              <Typography variant="body2" color="#856404" sx={{ mt: 1 }}>
                The file was uploaded but contains no valid data rows.
                <br />
                Please check the file format and content.
              </Typography>
            </Box>
          ) : null}
        </>
      )}

      {csvData.length > 0 && (
        <Box
          sx={{
            my: 3,
            p: 3,
            backgroundColor: "#5523D2",
            color: "white",
            borderRadius: 2,
            textAlign: "center",
            fontSize: "1.2rem",
          }}
        >
          Total Amount: ${totalAmount} | Employees: {csvData.length}
        </Box>
      )}

      {validationErrors.length > 0 && (
        <Box
          sx={{
            my: 3,
            p: 3,
            backgroundColor: "#fff3cd",
            border: "1px solid #ffeaa7",
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" color="#856404">
            {validationErrors.length} Validation Issue(s) Found
          </Typography>
          <Box sx={{ mt: 1, maxHeight: "300px", overflowY: "auto", pr: 1 }}>
            <Typography
              variant="body2"
              color="#856404"
              component="div"
              sx={{ whiteSpace: "pre-line" }}
            >
              {validationErrors.map((e) => `• ${e.message}`).join("\n")}
            </Typography>
          </Box>
          <Typography
            variant="body2"
            color="#856404"
            sx={{ mt: 2, fontWeight: "bold" }}
          >
            Please fix the highlighted rows before submitting.
          </Typography>
        </Box>
      )}

      {/* Read-only data review table */}
      {csvData.length > 0 && (
        <Box className="csv-preview">
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
            <Typography variant="h6">Review Data</Typography>
          </Box>
          <div
            style={{
              maxHeight: "500px",
              overflow: "auto",
              border: "1px solid #ddd",
              borderRadius: "4px",
            }}
          >
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead
                style={{ background: "#f0f0f0", position: "sticky", top: 0 }}
              >
                <tr>
                  {csvData[0] &&
                    Object.keys(csvData[0]).map((key) => (
                      <th
                        key={key}
                        style={{
                          padding: "12px",
                          border: "1px solid #ddd",
                          textAlign: "left",
                          minWidth: "120px",
                          fontWeight: 600,
                          fontSize: "0.875rem",
                          color: "#ddd",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {key}
                      </th>
                    ))}
                </tr>
              </thead>
              <tbody>
                {csvData.map((row, i) => (
                  <tr
                    key={i}
                    style={{ background: i % 2 === 0 ? "#fff" : "#f9fafb" }}
                  >
                    {csvData[0] &&
                      Object.keys(csvData[0]).map((key) => (
                        <td
                          key={key}
                          style={{
                            padding: "10px 12px",
                            border: "1px solid #eee",
                            fontSize: "0.875rem",
                            color: "#1e293b",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {row[key] || "—"}
                        </td>
                      ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Box>
      )}

      {uploadProgress.isUploading && (
        <Box
          sx={{
            mt: 3,
            p: 3,
            backgroundColor: "#5523D2",
            color: "white",
            borderRadius: 2,
            textAlign: "center",
            fontSize: "1.1rem",
          }}
        >
          <CircularProgress size={30} sx={{ color: "white", mb: 2 }} />
          <Typography variant="h6">{uploadProgress.message}</Typography>
          <Typography variant="body1" sx={{ mt: 1 }}>
            {uploadProgress.processed} / {uploadProgress.total} records
          </Typography>
          <Box
            sx={{
              width: "80%",
              bgcolor: "rgba(255,255,255,0.3)",
              borderRadius: 2,
              height: 10,
              mx: "auto",
              mt: 2,
            }}
          >
            <Box
              sx={{
                width: `${(uploadProgress.processed / uploadProgress.total) * 100 || 0}%`,
                bgcolor: "white",
                height: "100%",
                borderRadius: 2,
                transition: "width 0.3s ease",
              }}
            />
          </Box>
        </Box>
      )}

      <Box className="action-bar" sx={{ mt: 4 }}>
        <Tooltip
          title={
            uploadProgress.isUploading
              ? "Scheduling in progress..."
              : validationErrors.length > 0
                ? "Fix validation errors before scheduling"
                : csvData.length === 0 && fileName
                  ? "Batch has 0 records - cannot schedule"
                  : ""
          }
        >
          <span>
            <button
              onClick={handleScheduleClick}
              className="schedule-btn"
              disabled={
                uploadProgress.isUploading ||
                !fileName ||
                validationErrors.length > 0 ||
                (csvData.length === 0 &&
                  !fileName.toLowerCase().endsWith(".zip"))
              }
            >
              {uploadProgress.isUploading
                ? "Scheduling..."
                : "Submit & Schedule Payroll"}
            </button>
          </span>
        </Tooltip>
      </Box>

      {successfulSchedule && (
        <Box
          sx={{
            mt: 3,
            p: 3,
            backgroundColor: "#d4edda",
            color: "#155724",
            borderRadius: 2,
          }}
        >
          Payroll submitted successfully! Status: <strong>Open</strong>
        </Box>
      )}

      {showPinPad && (
        <PinPad
          show={showPinPad}
          handleConfirm={handlePinConfirm}
          onClick={() => {
            if (pinProcessing) return; // don't let the user dismiss it mid-request
            setShowPinPad(false);
          }}
          loading={pinProcessing}
        />
      )}
      <CustomAlert
        severity={alert.severity}
        show={alert.open}
        header={alert.header}
        message={alert.message}
        onClick={() => setAlert({ ...alert, open: false })}
        autoclose={alert.severity === "success"}
      />
    </Box>
  );
}

export default SchedulePayrollBatch;
